// extracted by mini-css-extract-plugin
module.exports = {"content":"myLife_content__2NAqZ","imgBox":"myLife_imgBox__3tCI2"};